<template>
  <div class="landing">
    <v-overlay :absolute="false" :opacity="0.46" :value="overlay" :z-index="5">
      <v-progress-circular :size="100" :width="7" color="#4dbac0" indeterminate>
        <span class="text-center">waiting for PayPal</span>
      </v-progress-circular>
    </v-overlay>
    <v-row class="px-12">
      <v-col lg="12" style="padding:8px;">
        <v-container>
          <v-row>
            <v-col xl="5" lg="5" md="5" sm="12" xs="12" class="px-6">
              <div class="text-center">
                <div>
                  <img
                    alt="logo"
                    :class="$vuetify.breakpoint.xsAndDown ? 'logo-img-small':'logo-img mt-4'"
                    style="padding-left: 70px"
                    :src="require('@/assets/img/logo.svg')"
                  />
                  <div>
                    <span class="condbold">
                      <b>Trading framework</b>
                    </span>
                    <div
                      class="text-center infotext mt-4 mb-4"
                    >Solution for personal and team trading data management. Log your steps realtime and get feedback using our trading framework immediately. We are leader on the way from trading anarchy to trading rules.</div>

                    <v-row align="center" justify="center">
                      <v-btn
                        v-if="!loggedIn"
                        small
                        color="#79C04D"
                        @click="gotoapp"
                        class="float-left mr-2"
                        rounded
                      >Sign Up</v-btn>
                      <v-btn
                        v-else
                        small
                        color="#79C04D"
                        @click="gotoapp"
                        class="float-left mr-2"
                        rounded
                      >Go To App</v-btn>
                      <div class="float-left ml-2 pt-1">
                        <form
                          action=""
                          method="post"
                          target="_top"
                        >
                          <input type="hidden" name="cmd" value="_s-xclick" />
                          <input type="hidden" name="hosted_button_id" value="KXD6M2D8XFWCN" />
                          <input
                            @click="overlay = true"
                            type="image"
                            src="https://www.paypalobjects.com/en_US/i/btn/btn_donate_LG.gif"
                            border="0"
                            name="submit"
                            title="PayPal - The safer, easier way to pay online!"
                            alt="Donate with PayPal button"
                          />
                        </form>
                      </div>
                    </v-row>
                    <div class="mt-4 condbold darkgrey">
                      <b>Supported trading platforms</b>
                    </div>
                    <img
                      class="platforms-img mt-1"
                      alt="trading_platforms"
                      :src="require('@/assets/img/platforms4.png')"
                    />
                  </div>
                </div>
              </div>
              <!--<h1>TRADING FRAMEWORK</h1>
              <li>Get the maximum from your trading</li>
              <li>Intraday, day and swing trading e-minis/micros</li>
              <li>Control your emotion and learn from history</li>
              <li>Relax your trading using Prepare and Journal</li>
              <li>Manage trading zones and their stats effectively</li>
              <li>Use as self-coaching or connect to a mentor</li>
              <li>Improve your strategies and keep they actual</li>
              <li>Create your own trading net with other traders</li>
              <li>Diversify your trading style using other know-how</li>
              <li>Switch trading anarchy to trading system</li>
              <li>Realtime share your journal with followers</li>
              -->
            </v-col>
            <v-col xl="7" lg="7" md="7" sm="12" xs="12" class="text-center">
              <img alt="media_view" class="mt-1" :src="require('@/assets/img/view2.png')" />
              <!--
              <v-card elevation="6">
                <v-carousel height="430">
                  <v-carousel-item
                    v-for="(item,i) in items"
                    :key="i"
                    :src="item.src"
                    reverse-transition="fade-transition"
                    transition="fade-transition"
                  ></v-carousel-item>
                </v-carousel>
              </v-card>
              -->
            </v-col>
          </v-row>
        </v-container>
        <v-lazy
          v-model="isActive"
          :options="{
          threshold: .5
        }"
          min-height="100"
          transition="fade-transition"
        >
          <v-container>
            <v-row>
              <transition name="fade">
              <v-col v-if="dataLoaded" cols="12" class="mt-12" style="padding:8px;">
                <v-row>
                  <v-col xl="2" lg="2" md="4" sm="6" xs="6" class="px-6">
                    <v-card elevation="6">
                      <div class="stat-number">{{data.users}}</div>
                      <div class="stat-text">Users</div>
                    </v-card>
                  </v-col>
                  <v-col xl="2" lg="2" md="4" sm="6" xs="6" class="px-6">
                    <v-card elevation="6">
                      <div class="stat-number">{{data.days}}</div>
                      <div class="stat-text">Diary Days</div>
                    </v-card>
                  </v-col>
                  <v-col xl="2" lg="2" md="4" sm="6" xs="6" class="px-6">
                    <v-card elevation="6">
                      <div class="stat-number">{{data.levels}}</div>
                      <div class="stat-text">Trading Levels</div>
                    </v-card>
                  </v-col>
                  <v-col xl="2" lg="2" md="4" sm="6" xs="6" class="px-6">
                    <v-card elevation="6">
                      <div class="stat-number">{{data.trades}}</div>
                      <div class="stat-text">Trades</div>
                    </v-card>
                  </v-col>
                  <v-col xl="2" lg="2" md="4" sm="6" xs="6" class="px-6">
                    <v-card elevation="6">
                      <div class="stat-number">{{data.prepares}}</div>
                      <div class="stat-text">Trade Prepares</div>
                    </v-card>
                  </v-col>
                  <v-col xl="2" lg="2" md="4" sm="6" xs="6" class="px-6">
                    <v-card elevation="6">
                      <div class="stat-number">{{data.strategies}}</div>
                      <div class="stat-text">Strategies</div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
              </transition>

              <v-col cols="12" class="mt-12" style="padding:8px;">
                <h1>FEATURES</h1>
                <v-row>
                  <v-col xl="6" lg="6" md="6" sm="12" xs="12">
                    <v-card elevation="6">
                      <div class="d-flex flex-no-wrap justify-space-between">
                        <v-avatar class size="155" tile>
                          <v-img
                            alt="diary_preview"
                            :src="require('@/assets/img/diary_prew_1.png')"
                          ></v-img>
                        </v-avatar>
                        <div>
                          <v-card-title class="subtitle">Trading Journal</v-card-title>
                          <v-card-text
                            class="infotext"
                          >Realtime auto-generated diary with day and trade details. Realtime log of all you steps such as trades, canceled Trade Prepares, created/deleted levels and more...</v-card-text>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" xs="12">
                    <v-card elevation="6">
                      <div class="d-flex flex-no-wrap justify-space-between">
                        <v-avatar class size="150" tile>
                          <v-img
                            alt="strategy_preview"
                            :src="require('@/assets/img/strategy_prew_1.png')"
                          ></v-img>
                        </v-avatar>
                        <div>
                          <v-card-title class="subtitle">Tags and Strategies</v-card-title>
                          <v-card-text
                            class="infotext"
                          >Create your trade tags and strategies. It helps you to see partial statistics of your trading. Every tag and strategy have own timeline to keep history of changes.</v-card-text>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" xs="12">
                    <v-card elevation="6">
                      <div class="d-flex flex-no-wrap justify-space-between">
                        <v-avatar class size="150" tile>
                          <v-img
                            alt="checklist_preview"
                            :src="require('@/assets/img/checklist_prew_1.png')"
                          ></v-img>
                        </v-avatar>
                        <div>
                          <v-card-title class="subtitle">Strategy Checklist</v-card-title>
                          <v-card-text
                            class="infotext"
                          >Scale down the trading anarchy using checklists and make your trading profesional using Strategy Checklist in Trade Prepare. Landing gear, flaps...</v-card-text>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" xs="12">
                    <v-card elevation="6">
                      <div class="d-flex flex-no-wrap justify-space-between">
                        <v-avatar class size="150" tile>
                          <v-img alt="prepare_preview" :src="require('@/assets/img/prepare.png')"></v-img>
                        </v-avatar>
                        <div>
                          <v-card-title class="subtitle">Trade Prepare</v-card-title>
                          <v-card-text
                            class="infotext"
                          >Build the systematic trading using our Trade Prepare. Trade Prepare generates wealth and valuable statistics not retrospective affected by the trade result.</v-card-text>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" xs="12">
                    <v-card elevation="6">
                      <div class="d-flex flex-no-wrap justify-space-between">
                        <v-avatar class size="150" tile>
                          <v-img alt="zone_preview" :src="require('@/assets/img/zone.png')"></v-img>
                        </v-avatar>
                        <div>
                          <v-card-title class="subtitle">Zone Management</v-card-title>
                          <v-card-text
                            class="infotext"
                          >Create zones in our trading framework and get a zone statistics with no extra work. Zones are projecteted to your trading platform and easy shareable between users.</v-card-text>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" xs="12">
                    <v-card elevation="6">
                      <div class="d-flex flex-no-wrap justify-space-between">
                        <v-avatar class size="150" tile>
                          <v-img
                            alt="community_preview"
                            :src="require('@/assets/img/community.png')"
                          ></v-img>
                        </v-avatar>
                        <div>
                          <v-card-title class="subtitle">Community</v-card-title>
                          <v-card-text
                            class="infotext"
                          >Trading is solitary. Meet new traders with the similar goals and discuss in objective oriented discussion. Get opponents opinion and avoid blind aisles.</v-card-text>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="12" class="text-center">and much more...</v-col>
                </v-row>
              </v-col>
              <!--
            <v-col cols="12" class="mt-12" style="padding:8px;">
              <h1>ABOUT US</h1>
              <v-row>
                <v-col cols="6">
                  <v-card elevation="6">
                    <v-card-title>Founder</v-card-title>
                    <v-card-text>Private trader with 10 years trading experiences, programmer, consultant, tradingpool.cz founder</v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6">
                  <v-card elevation="6">
                    <v-card-title>TradingPool.cz team</v-card-title>
                    <v-card-text>This team generated over 20,000 trades for 3 years transfered to TradingPool.cz diary.</v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
              -->
            </v-row>
          </v-container>
        </v-lazy>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "home",
  components: {},
  data() {
    return {
      dataLoaded: false,
      isActive: false,
      overlay: false,
      loading: true,
      hoverLM: false,
      hoverSU: false,
      items: [
        {
          src: require("@/assets/img/page_02.png")
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/sky.jpg"
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/bird.jpg"
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/planet.jpg"
        }
      ]
    };
  },

  computed: {
    loggedIn() {
      return this.$store.getters.loggedIn;
    }
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  },
  methods: {
    gotoapp() {
      if (this.loggedIn) return this.$router.push("/pool");
      else return this.$router.push("/register");
    },
    paypalRedirect() {
      this.redirecting = true;
    }
  },
  asyncComputed: {
    data: {
      get() {
        return new Promise((resolve, reject) => {
          axios
            .post("https://tradeinpool.com:3001/api/request/landing/")
            .then(response => {
              this.dataLoaded = true
              resolve(response.data);
              
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      default: {
        levels: 0,
        trades: 0,
        users: 0,
        strategies: 0,
        prepares: 0,
        days: 0
      }
    }
  }
};
</script>

<style scoped>
.logo-img {
  height: 80px;
}
.logo-img-small {
  height: 40px;
}

.platforms-img {
  height: 60px;
}

.page-img {
  width: 320px;
  margin-bottom: 0px;
}

.cardimg {
  width: 30%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.public-text {
  color: #b6c1ca;
}
.title-small {
  font-size: 20px;
}
.widthBtn {
  width: 140px;
  text-align: center;
  -webkit-transition: width 2s, height 4s; /* For Safari 3.1 to 6.0 */
  transition: width 1s, height 4s, text-align 1s;
}
.widthBtn:hover {
  width: 160px;
  text-align: center;
}

.condbold {
  size: 16px;
  font-family: "Roboto Condensed", sans-serif;
}
.darkgrey {
  color: #808f9c;
}

.infotext {
  color: #b6c1cb;
  size: 12px !important;
  font-family: "Roboto", sans-serif;
}

.landing h1 {
  font-weight: bold;
  font-size: 20px;
  color: #808f9c;
  font-family: "Roboto Condensed", sans-serif;
}

.subtitle {
  font-weight: bold;
  font-size: 20px;
  color: white;
  font-family: "Roboto Condensed", sans-serif;
}

.stat-text {
  font-size: 16px;
  color: #b6c1ca;
  font-family: "Roboto Condensed", sans-serif;
  font-weight: bold;
  text-align: center;
}

.stat-number {
  font-size: 50px;
  font-family: "Roboto Condensed", sans-serif;
  font-weight: bold;
  text-align: center;
}
</style>